import { render, staticRenderFns } from "./facturasAbono.vue?vue&type=template&id=3129119a&scoped=true"
import script from "./facturasAbono.vue?vue&type=script&lang=js"
export * from "./facturasAbono.vue?vue&type=script&lang=js"
import style0 from "./facturasAbono.vue?vue&type=style&index=0&id=3129119a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129119a",
  null
  
)

export default component.exports